// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Button, message, Avatar } from "antd";
// import {
//   HomeOutlined,
//   DashboardOutlined,
//   LogoutOutlined,
//   ContactsOutlined,
//   UserOutlined,
// } from "@ant-design/icons";
// import { motion } from "framer-motion";

// const Navbar = ({ user, setUser }) => {
//   const navigate = useNavigate();

//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkSize = () => setIsMobile(window.innerWidth <= 786);
//     checkSize();
//     window.addEventListener("resize", checkSize);
//     return () => window.removeEventListener("resize", checkSize);
//   }, []);

//   const handleLogout = () => {
//     setUser(null);
//     localStorage.removeItem("user");
//     message.success("Logged out successfully!");
//     navigate("/");
//   };

//   const isLoggedIn = Boolean(user);

//   const getInitials = (name = "") => {
//     if (!name) return "U";
//     const parts = name.trim().split(" ");
//     if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
//     return (parts[0][0] + parts[1][0]).toUpperCase();
//   };

//   const dashboardLink = user?.role === "admin" ? "/dashboard" : "/user-rules";

//   return (
//     <header
//       style={{
//         ...styles.header,
//         height: isMobile ? "60px" : "70px",
//         padding: isMobile ? "0 15px" : "0 40px",
//       }}
//     >
//       {/* BRAND */}
//       <Link
//         to="/"
//         style={{
//           ...styles.brand,
//           fontSize: isMobile ? "20px" : "28px",
//         }}
//       >
//         Yoga Wellness
//       </Link>

//       {/* RIGHT NAV */}
//       <nav style={{ ...styles.navLinks, gap: isMobile ? "10px" : "20px" }}>
//         {/* ⭐ HOME + CONTACT only when not logged in */}
//         {!isLoggedIn && (
//           <>
//             <Link
//               to="/"
//               style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}
//             >
//               <HomeOutlined /> {!isMobile && "Home"}
//             </Link>

//             <Link
//               to="/contact"
//               style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}
//             >
//               <ContactsOutlined /> {!isMobile && "Contact"}
//             </Link>
//           </>
//         )}

//         {/* ⭐ DASHBOARD BUTTON when logged in (admin or user) */}
//         {isLoggedIn && (
//           <Link
//             to={dashboardLink}
//             style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}
//           >
//             <DashboardOutlined /> {!isMobile && "Dashboard"}
//           </Link>
//         )}

//         {/* ⭐ LOGIN BUTTON */}
//         {!isLoggedIn && (
//           <Link to="/login">
//             <Button
//               type="primary"
//               icon={<UserOutlined />}
//               size={isMobile ? "small" : "middle"}
//             >
//               {!isMobile && "Login"}
//             </Button>
//           </Link>
//         )}

//         {/* ⭐ AVATAR + USERNAME + LOGOUT when logged in */}
//         {isLoggedIn && (
//           <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//             <Avatar
//               style={{
//                 backgroundColor: "#62bf6b",
//                 fontWeight: "bold",
//                 cursor: "pointer",
//               }}
//               size={isMobile ? 32 : 40}
//             >
//               {getInitials(user.name)}
//             </Avatar>

//             {!isMobile && (
//               <span style={{ fontSize: "16px", fontWeight: "500" }}>
//                 {user.name}
//               </span>
//             )}

//             <Button
//               type="default"
//               icon={<LogoutOutlined />}
//               size={isMobile ? "small" : "middle"}
//               onClick={handleLogout}
//             >
//               {!isMobile && "Logout"}
//             </Button>
//           </div>
//         )}
//       </nav>
//     </header>
//   );
// };

// const styles = {
//   header: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     backgroundColor: "#ffffff",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     zIndex: 1000,
//   },
//   brand: {
//     color: "#13171b",
//     fontWeight: "bold",
//     textDecoration: "none",
//   },
//   navLinks: {
//     display: "flex",
//     alignItems: "center",
//   },
//   link: {
//     color: "#333",
//     textDecoration: "none",
//   },
// };

// export default Navbar;
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, message } from "antd";
import Logo from "../../src/assets/Logo.png";
import {
  HomeOutlined,
  DashboardOutlined,
  LogoutOutlined,
  ContactsOutlined,
  UserOutlined,
} from "@ant-design/icons";


const Navbar = ({ user, setUser }) => {
  const navigate = useNavigate();

  
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkSize = () => setIsMobile(window.innerWidth <= 786);
    checkSize();
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
    message.success("Logged out successfully!");
    navigate("/");
  };

  return (
    <header
      style={{
        ...styles.header,
        height: isMobile ? "60px" : "70px",
        padding: isMobile ? "0 15px" : "0 40px",
      }}
    >
      {/* LEFT: Brand */}
      <Link to="/" style={styles.brand}>
  <img
    src={require("../../src/assets/Logo.png")}
    alt="Yoga Refer.com"
    style={{
      height: isMobile ? "60px" : "70px",
      width: "auto",
      objectFit: "contain",
    }}
  />
</Link>
      
      {/* RIGHT NAV */}
      <nav
        style={{
          ...styles.navLinks,
          gap: isMobile ? "10px" : "20px",
        }}
      >
        <Link to="/" style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}>
          <HomeOutlined /> {!isMobile && "Home"}
        </Link>

        <Link to="/contact" style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}>
          <ContactsOutlined /> {!isMobile && "Contact"}
        </Link>

        {user && (
          <Link
            to="/dashboard"
            style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}
          >
            <DashboardOutlined /> {!isMobile && "Dashboard"}
          </Link>
        )}

        {user ? (
          <Button
            type="default"
            icon={<LogoutOutlined />}
            size={isMobile ? "small" : "middle"}
            onClick={handleLogout}
          >
            {!isMobile && "Logout"}
          </Button>
        ) : (
          <Link to="/login">
            <Button
              type="primary"
              icon={<UserOutlined />}
              size={isMobile ? "small" : "middle"}
            >
              {!isMobile && "Login"}
            </Button>
          </Link>
        )}
      </nav>
    </header>
  );
};

const styles = {
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    background: "linear-gradient(to right, rgb(255, 215, 0), rgb(255, 165, 0))",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 1000,
    fontfamily: "manrope",
    
  },

  brand: {
    color: "#13171bff",
    fontWeight: "bold",
    textDecoration: "none",
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
  },
  link: {
    color: "#333",
    textDecoration: "none",
  },
 
};

export default Navbar;

